import type { FlatItem } from './types';
import { isFlatLineItem } from './types';

/** Every selectable id: all line-item ids + all project-header ids. */
export function getAllSelectableIds(flatItems: FlatItem[]): Set<string> {
  return new Set(flatItems.map((item) => item.id));
}

/**
 * Master select-all state, derived over line items only. A project header cannot
 * stay unchecked while its members are checked (handleCheckProject toggles them as
 * a unit), so the line-item count fully determines the master state.
 */
export function computeSelectAllState(
  flatItems: FlatItem[],
  checkedIds: Set<string>,
): { isChecked: boolean; isIndeterminate: boolean } {
  const lineItems = flatItems.filter(isFlatLineItem);
  if (lineItems.length === 0) return { isChecked: false, isIndeterminate: false };
  const checkedCount = lineItems.reduce(
    (n, item) => (checkedIds.has(item.id) ? n + 1 : n),
    0,
  );
  return {
    isChecked: checkedCount === lineItems.length,
    isIndeterminate: checkedCount > 0 && checkedCount < lineItems.length,
  };
}
